/// <amd-module name="Wit/WorkItems/DataSources/WorkItemFieldsAllowedValuesDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const WorkItemFieldsAllowedValuesId = "ms.vss-work-web.work-item-fields-allowed-values-provider";

interface IAllowedValuesProviderRequestProperties {
    workItemTypeName: string;
    projectId: string;
    workItemId: number;
    fieldRefName: string;
}

export function getAllowedValuesAsync(
    pageContext: IVssPageContext,
    projectGuid: string,
    workItemTypeName: string,
    workItemId: number,
    fieldRefName: string
): Promise<string[] | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const requestProperties: IAllowedValuesProviderRequestProperties = {
        projectId: projectGuid,
        workItemTypeName,
        workItemId,
        fieldRefName
    };

    // Force a roundtrip
    return contributionService.getDataAsync<string[]>(WorkItemFieldsAllowedValuesId, requestProperties, /* ignoreCache */ true);
}
